import { useTranslation } from "react-i18next";
import { Link, useLocation } from "wouter";

/** Tab strip shared by the three alert pages: Urgent / Archived / Stockout audit. */
export function AlertsTabs() {
  const { t } = useTranslation();
  const [loc] = useLocation();
  const tabs = [
    { href: "/alerts", label: t("alerts:tabs.urgent") },
    { href: "/alerts/archived", label: t("alerts:tabs.archived") },
    { href: "/alerts/audit", label: t("alerts:tabs.audit") },
  ];
  return (
    <nav className="mb-4 flex gap-1 border-b" aria-label={t("alerts:title")}>
      {tabs.map((tab) => {
        const active = loc === tab.href;
        return (
          <Link
            key={tab.href}
            href={tab.href}
            aria-current={active ? "page" : undefined}
            className={
              active
                ? "-mb-px border-primary border-b-2 px-3 py-2 font-medium text-sm"
                : "px-3 py-2 text-muted-foreground text-sm hover:text-foreground"
            }
          >
            {tab.label}
          </Link>
        );
      })}
    </nav>
  );
}
